import { render, staticRenderFns } from "./AddDish.vue?vue&type=template&id=71516f66&scoped=true&"
import script from "./AddDish.vue?vue&type=script&lang=ts&"
export * from "./AddDish.vue?vue&type=script&lang=ts&"
import style0 from "./AddDish.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddDish.vue?vue&type=style&index=1&id=71516f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71516f66",
  null
  
)

export default component.exports